import {path, pipe, prop} from 'ramda';
import {createSelector} from 'reselect';
import namespace from './namespace';
import {selectors as lifecycleSelectors} from 'fragments/lifecycle';
import {formatFetchableLeadsQuery} from './utils';
import * as commonSelectors from 'modules/common/selectors';
import * as perms from 'utils/perms';
import {TABS} from './constants';

const root = path(namespace);

export const {seq} = lifecycleSelectors(namespace);

export const initialized = pipe(root, prop('initialized'));

export const leads = pipe(root, prop('leads'));

export const leadsLoading = pipe(root, prop('leadsLoading'));

export const leadsPagination = pipe(root, prop('leadsPagination'));

export const urlQuery = pipe(root, prop('urlQuery'));

export const leadsQuery = pipe(root, prop('leadsQuery'));

export const canReadAllLeads = createSelector([commonSelectors.user], user =>
	perms.canReadAllLeads(user),
);

export const canReadAllOrganizationLeads = createSelector(
	[commonSelectors.user, canReadAllLeads],
	(user, canReadAllLeads) => perms.canReadAllOrganizationLeads(user) || canReadAllLeads,
);
export const canReadAllTeamLeads = createSelector(
	[commonSelectors.user, canReadAllLeads, canReadAllOrganizationLeads],
	(user, canReadAllLeads, canReadAllOrganizationLeads) =>
		perms.canReadAllOwnTeamLeads(user) || canReadAllLeads || canReadAllOrganizationLeads,
);

export const isSalesmanager = createSelector([commonSelectors.user], user =>
	perms.isSalesmanagerUser(user),
);

/*prettier-ignore*/
export const leadsQueryFetchable = createSelector(
	[leadsQuery,commonSelectors.user, commonSelectors.activeOrganization, canReadAllLeads, canReadAllOrganizationLeads],
	(leadsQuery,user, activeOrganization, canReadAllLeads, canReadAllOrganizationLeads) =>
		formatFetchableLeadsQuery({
			leadsQuery,
			userId: user.id,
			organizationId: activeOrganization.id,
			canReadAllLeads,
			canReadAllOrganizationLeads
		}),
);

/*prettier-ignore*/
export const ownerLeads = createSelector(
	[leadsQuery],
	(leadsQuery) =>
		leadsQuery.tab === TABS.OWNER,
);

export const tab = createSelector([leadsQuery], leadsQuery => leadsQuery.tab);

export const processing = pipe(root, prop('processing'));

export const leadToDelete = pipe(root, prop('leadToDelete'));
